import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseResizableComponent } from '@src/app/modules/base';

import { LoyaltyProgramListProduct } from '../../models';

@Component({
  selector: 'lp-products-carousel',
  templateUrl: './products-carousel.component.html',
  styleUrls: ['./products-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductsCarouselComponent extends BaseResizableComponent {
  @Input() products?: readonly LoyaltyProgramListProduct[] | null = null;

  @Input() showIsFavorite: boolean = false;
}
